/**
 * Сборка роутера. Здесь только склейка — таблица лежит в `routes.ts`,
 * решения о доступе в `guards.ts`.
 */
import { createRouter, createWebHistory } from 'vue-router'
import { registerGuards } from './guards'
import { routes } from './routes'

const router = createRouter({
  // `createWebHistory` (а не hash): панель отдаётся Vite dev-сервером и любым
  // статик-хостом с fallback на index.html, красивые URL шарятся в переписке.
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,

  /**
   * Назад/вперёд возвращают человека туда, где он был (браузер сохранил
   * позицию); любая новая навигация — в начало страницы. Без этого переход
   * с середины длинного списка пользователей на форму открывает форму
   * прокрученной вниз.
   */
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { top: 0 }
  },
})

registerGuards(router)

/**
 * Реэкспорт ради `LoginView` (F3-E): `?redirect=` обязан проходить через
 * общую проверку, а не через локальную копию. Цикла импортов нет — вью
 * подгружаются лениво, уже после того как этот модуль вычислен.
 */
export { safeRedirect } from './guards'
export { routes } from './routes'

export default router
